import React from "react";
import { useSelector } from "react-redux";

import { Card } from "@material-ui/core";

export const EmpadronamientoCard = (props) => {
  const { afiliadoSeleccionado = {}, solicitudSeleccionada } = useSelector(
    (state) => state.empadronamiento
  );
  
  const id = solicitudSeleccionada !== null && solicitudSeleccionada?.idSolicitud ? " / Solicitud Nº" + solicitudSeleccionada?.idSolicitud : null;

  return (
    <Card
      elevation={3}
      style={{ width: props.width, margin: "auto", marginTop: "2rem" }}
    >
      <div style={{ textAlign: "center", marginTop: "0.5rem" }}>
        <div
          style={{
            display: "inline-block",
            width: afiliadoSeleccionado?.judicializado ? "70%" : "98%",
            backgroundColor: afiliadoSeleccionado?.fecha_baja ? "red" : "green",
            borderRadius: "0.25rem",
            color: "white",
            fontWeight: "bold",
            fontSize: "1rem",
            textAlign: "center",
            padding: "0.25rem 0",
          }}
        >{`${afiliadoSeleccionado?.apellido_y_nombre} / CUIL: ${afiliadoSeleccionado?.cuil}${id ? id : ""}`}</div>
        {afiliadoSeleccionado?.judicializado && (
          <div
            style={{
              display: "inline-block",
              width: "28%",
              backgroundColor: "red",
              borderRadius: "0.25rem",
              color: "white",
              fontWeight: "bold",
              fontSize: "1rem",
              textAlign: "center",
              padding: "0.25rem 0",
            }}
          >
            Judicializado
          </div>
        )}
      </div>
      {props.children}
    </Card>
  );
};
